<header>
  <div class="container">
    <div class="row align-items-center">
      <div class="col-6 col-lg-6">
        <div class="d-flex gap-lg-4 align-items-center py-3">
          <img src="./assets/ctm-images/ctm-logo1.svg" tabindex="0" class="logo onMobile" alt="Compare the Market"
            (click)="logo()" />
          <img src="./assets/ctm-images/ctm-logo.svg" tabindex="0" class="logo onDesktop" alt="Compare the Market"
            (click)="logo()" />
          <div class="px-4 fs-20 py-1 border-start border-2 onDesktop">Energy</div>
          <div class="px-4 fs-20 py-1 onMobile">Energy</div>
        </div>
      </div>
      <div class="col-6 col-lg-6 text-end">
        <div class="py-3">
          <button id="EnergyComparison_Header_SignIn" class="btn btn-primary-outline reduceOnMobile"
            [ngClass]="isLoggedIn ? 'cy-header-signOut' : 'cy-header-signIn'" (click)="sign(isLoggedIn)">{{ isLoggedIn ?
            'Sign out' : 'Sign in' }}</button>
        </div>
      </div>
    </div>
  </div>
</header>